import { createSelector } from '@ngrx/store';
import { IContacts } from '../interfaces/contact.interfaces';

export const selectContactsState = state => state.cmms.contactsState;

export const getContactsList = createSelector(
	selectContactsState,
	(state: IContacts) => state.contacts
);
